// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1w59-","text":"SelectPayment_text__36h7U","title":"SelectPayment_title__3biSK","btn":"SelectPayment_btn__Sz-o7"};